import {NgModule} from '@angular/core';
import {BsDropdownModule, PaginationModule, ModalModule, BsModalService, TooltipModule, BsModalRef, TabsModule} from 'ngx-bootstrap';
import {TableModule} from 'ngx-easy-table';
import {NgSelectModule} from '@ng-select/ng-select';
import {ClipboardModule} from 'ngx-clipboard';
import {LMarkdownEditorModule} from 'ngx-markdown-editor';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ToasterModule} from 'angular2-toaster';
import {LaddaModule} from 'angular2-ladda';
import {ApiService, AppCommonModule, HttpLoaderFactory, LocaleConfig} from '@common-lib';

import {PluginGotenehusMappingComponent} from './plugin-gotenehus-mapping/plugin-gotenehus-mapping.component';
import {PluginGotenehusMappingDataComponent} from './plugin-gotenehus-mapping-data/plugin-gotenehus-mapping-data.component';
import {PluginGotenehusProductRegionsComponent} from './plugin-gotenehus-product-regions/plugin-gotenehus-product-regions.component';
import {PluginGotenehusRegionsComponent} from './plugin-gotenehus-regions/plugin-gotenehus-regions.component';
import {PluginGotenehusMappingService} from '../pages-services/plugin-gotenehus-mapping.service';
import {PluginGotenehusMappingDataService} from '../pages-services/plugin-gotenehus-mapping-data.service';
import {PluginGotenehusRegionsService} from '../pages-services/plugin-gotenehus-regions.service';
import {PluginGotenehusProductRegionsService} from '../pages-services/plugin-gotenehus-product-regions.service';

import {NoAuthGuard, AuthGuard} from '../core';
import {SharedModule} from '../shared';
import {SettingsComponent} from './settings/settings.component';
import {PagesRouting} from './pages-routing';
import {AuthComponent} from './auth/auth.component';
import {ProductsComponent} from './products/products.component';
import {VariantsComponent} from './variants/variants.component';
import {PagesComponent} from './pages/pages.component';
import {MediaComponent} from './media/media.component';
import {VariantEditComponent} from './variant-edit/variant-edit.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {SettingsTranslationsComponent} from './settings-translations/settings-translations.component';
import {SettingsUsersComponent} from './settings-users/settings-users.component';
import {SettingsPermissionsComponent} from './settings-permissions/settings-permissions.component';
import {RestorePasswordComponent} from './restore-password/restore-password.component';
import {ConfigurationComponent} from './configuration/configuration.component';
import {SettingsMarketsComponent} from './settings-markets/settings-markets.component';
import {
    CategoriesService,
    ConfigurationService,
    MarketsService, MediaService,
    PagesService, PermissionsService, ProductSettingsService,
    ProductsService,
    SettingsService, SubcategoriesService,
    TranslationsService,
    UsersService,
    VariantEditService,
    VariantsService
} from '../pages-services';
import {
    BottomToolbarComponent,
    ConfirmPopupComponent,
    ExportButtonComponent, ImportButtonComponent, SyncButtonComponent,
    LanguageDropdownComponent,
    LoadingSpinnerComponent
} from '../components';
import {SettingsProductSettingsComponent} from './settings-product-settings/settings-product-settings.component';
import {ConfigurationVariantGroupsComponent} from './configuration-variant-groups/configuration-variant-groups.component';
import {ConfigurationProductsComponent} from './configuration-products/configuration-products.component';
import {ConfigurationNavigationComponent} from './configuration-navigation/configuration-navigation.component';
import {ConfigurationCategoriesComponent} from './configuration-categories/configuration-categories.component';
import {ConfigurationSubcategoriesComponent} from './configuration-subcategories/configuration-subcategories.component';
import {ConfigurationViewsComponent} from './configuration-views/configuration-views.component';
import {UploadAssetsComponent} from "../components/upload-assets/upload-assets.component";
import {UploadAssetsService} from "../services/upload-assets.service";
import { DashboardComponent } from './dashboard/dashboard.component';
import {DashboardChartPaneComponent} from "../components/dashboard-chart-pane/dashboard-chart-pane.component";
import {DashboardChartsComponent} from "../components/dashboard-charts/dashboard-charts.component";
import {DashboardChartsSelectorComponent} from "../components/dashboard-charts-selector/dashboard-charts-selector.component";
import {DashboardCommonStatsComponent} from "../components/dashboard-common-stats/dashboard-common-stats.component";
import {AnalyticsDashboardService} from "../services/analytics-dashboard.service";
import {PrettyJsonModule} from "angular2-prettyjson";



@NgModule({
    imports: [
        ClipboardModule,
        SharedModule,
        PagesRouting,
        NgSelectModule,
        LMarkdownEditorModule,
        TableModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [ApiService, LocaleConfig]
            }
        }),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        PaginationModule.forRoot(),
        TabsModule.forRoot(),
        AppCommonModule,
        ToasterModule.forChild(),
        LaddaModule.forRoot({
            style: 'slide-right',
            spinnerSize: 30
        }),
        PrettyJsonModule
    ],
    entryComponents: [
        ConfirmPopupComponent
    ],
    declarations: [
        SettingsComponent,
        AuthComponent,
        ProductsComponent,
        VariantsComponent,
        PagesComponent,
        MediaComponent,
        VariantEditComponent,
        ResetPasswordComponent,
        SettingsTranslationsComponent,
        SettingsUsersComponent,
        SettingsPermissionsComponent,
        SettingsProductSettingsComponent,
        RestorePasswordComponent,
        ConfirmPopupComponent,
        ConfigurationComponent,
        ConfigurationProductsComponent,
        ConfigurationNavigationComponent,
        ConfigurationCategoriesComponent,
        ConfigurationSubcategoriesComponent,
        ConfigurationViewsComponent,
        ConfigurationVariantGroupsComponent,
        SettingsMarketsComponent,
        BottomToolbarComponent,
        LoadingSpinnerComponent,
        ExportButtonComponent,
        ImportButtonComponent,
        SyncButtonComponent,
        LanguageDropdownComponent,
        UploadAssetsComponent,
        DashboardComponent,
        DashboardChartPaneComponent,
        DashboardChartsComponent,
        DashboardChartsSelectorComponent,
        DashboardCommonStatsComponent,
        PluginGotenehusMappingComponent,
        PluginGotenehusMappingDataComponent,
        PluginGotenehusProductRegionsComponent,
        PluginGotenehusRegionsComponent
    ],
    providers: [
        NoAuthGuard,
        AuthGuard,
        BsModalService,
        PagesService,
        SettingsService,
        TranslationsService,
        UsersService,
        VariantsService,
        VariantEditService,
        ProductsService,
        CategoriesService,
        SubcategoriesService,
        ProductSettingsService,
        PermissionsService,
        MediaService,
        UsersService,
        MarketsService,
        ConfigurationService,
        BsModalRef,
        UploadAssetsService,
        AnalyticsDashboardService,
        PluginGotenehusMappingService,
        PluginGotenehusMappingDataService,
        PluginGotenehusProductRegionsService,
        PluginGotenehusRegionsService
    ]
})
export class PagesModule {
}



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts